import React, { useEffect, useState } from 'react';
import { View } from 'react-native';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../utils/apiRequest';
import { useSelector, useDispatch } from 'react-redux';
import { createFamilyAppointment, resetFamilyAppointmentState } from '../redux/actions/familyAppointmentActions';
import { setAppointmentId, setSessionsPerWeek, setSubjectId } from '../redux/actions/familyPresetValuesActions';
import CircularProgress from '@mui/material/CircularProgress';
// import {  StudentListModal , StudentFillDetails } from 'tutorapp-components';
import { StudentListModal } from 'tutorapp-components';
import StudentFillDetails from '../components/StudentFillDetails';


export default function StudentFillDetailsScreen() {

  const [isModalVisible, setModalVisible] = useState(false);
  const [studentlist, setStudentlist] = useState();
  const [selectedstudent, setSelectedstudent] = useState();
  const [subjectlist, setSubjectlist] = useState();
  const [loading, setloading] = useState(false);
  const [enData, setEnData] = useState();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selectedFranchise = useSelector((state) => state.franchise?.selectedFranchise);
  const appointmentId = useSelector((state) => state.familyPresetValues.appointmentId);
  const showschool = selectedFranchise.country == 'UK'


  // Filter students based on familyAppointment
  useEffect(() => {
    if (appointmentId && studentlist?.length > 0) {
      const filteredStudent = studentlist.find(
        (student) => student.id === appointmentId.id
      );
      setSelectedstudent(filteredStudent);
      handleStudentSelect(filteredStudent);
      dispatch(resetFamilyAppointmentState());
    }
  }, [studentlist]);

  const qwrqwdwq = {
    backarrow: './images/ic_back.svg',
    subjectIcon: './images/ic_subject.svg ',
    enrollmentIcon: './images/ic_enrollment.svg ',
    hoursIcon: './images/ic_remaining_hours.svg',
    studentIcon: './images/ic_student.svg',
    rightchevron: './images/ic_right.svg',
    sessionappointment: './images/ic_sessionappointment.svg',
    close: './images/ic_close.svg',
    progress: './images/ic_two.svg',
  };

  const icons = {
    search: './images/Search.svg',
    chevronup: './images/dropdown_close.svg',
    chevrondown: './images/dropdown.svg',
    subject: './images/Subject.svg',
    email: './images/ic_email.svg',
    phone: './images/Phone.svg',
    close: './images/ic_close2.svg',
  };

  const getstudentlisting = async (selectedFranchise) => {
    try {
      setloading(true);
      // const cancelappointment = process.env.REACT_APP_API_URL + 'getAllStudent';
      const cancelappointment = process.env.REACT_APP_API_URL + 'getAllActiveStudents';
      const options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          franchise_id: selectedFranchise.franchise_id,
          tutor_id: selectedFranchise.tutor_id,
          appointment_type: '0',
        }),
      };
      const response = await apiService(cancelappointment, options);
      if (response.status === 'success') {
        const mergedStudents = [
          ...Object.values(response.schools_student || {}),
          ...Object.values(response.families_student || {}),
        ];
        setStudentlist(mergedStudents);
      } else {
        console.error('Failed to fetch students:', response.message);
      }
    } catch (error) {
      console.error('Error while fetching students:', error);
    } finally {
      setloading(false);
    }
  };

  // const getsubjectlisting = async (selectedFranchise, student) => {
  //   try {
  //     setloading(true);
  //     const cancelappointment = process.env.REACT_APP_API_URL + 'getAllSubject';
  //     const options = {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify({
  //         franchise_id: selectedFranchise.franchise_id,
  //         tutor_id: selectedFranchise.tutor_id,
  //         appointment_type: '0',
  //         student_id: student?.id,
  //       }),
  //     };
  //     const response = await apiService(cancelappointment, options);
  //     if (response.status === 'success') {
  //       setSubjectlist(response.families_subject);
  //     } else {
  //       console.error('Failed to fetch subjects:', response.message);
  //     }
  //   } catch (error) {
  //     console.error('Error while fetching subjects:', error);
  //   } finally {
  //     setloading(false);
  //   }
  // };

  const handleStudentList = () => {
    setModalVisible(true);
  };

  const handleStudentSelect = (student) => {
    setSelectedstudent(student);
    // getsubjectlisting(selectedFranchise, student);
  };

  const handleSelectionClose = () => {
    navigate('/MyAppointment');
  };

  const handleback = () => {

         if (!showschool) {
          navigate("/MyAppointment");
        } else {
          navigate("/SelectAppointmentType");
        }
  }

  // Callback to receive data from child
  const handleContinueFromChild = (data) => {
    dispatch(createFamilyAppointment(data.formattedData));
    dispatch(setSessionsPerWeek(data.sessionPerWeek));
    dispatch(setSubjectId(data.subjectId));
    dispatch(setAppointmentId(data.formattedData)); // Store all data as appointmentId
    navigate('/student-date-time');
  };

  useEffect(() => {
    getstudentlisting(selectedFranchise);
  }, []);

  const getsubjectlisting = async (enrollmentId, selectedFranchise, student) => {
      try {
        setloading(true);
        const subjectListingUrl = process.env.REACT_APP_API_URL + 'getEnrollmentDetails';
        const options = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            enrollment_id: enrollmentId,
            tutor_id: selectedFranchise.tutor_id,
            student_id: student?.id,
          }),
        };
        const response = await apiService(subjectListingUrl, options);
        if (response.status === 'success') {
          setSubjectlist(response.enrollment_details.subjects);
          setEnData(response.enrollment_details);
        } else {
          console.error('Failed to fetch subjects:', response.message);
        }
      } catch (error) {
        console.error('Error while fetching subjects:', error);
      } finally {
        setloading(false);
      }
  };
  
  return (
    <div>
      {loading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
          }}
        >
          <CircularProgress
            size={40}
            sx={{ color: 'black' }}
            aria-label="Loading"
          />
        </div>
      )}
      <StudentFillDetails
        handleEditGeneral={() => navigate('/editAppointment')}
        selectedstudent={selectedstudent}
        handleStudentList={handleStudentList}
        icons={qwrqwdwq}
        subjectlist={subjectlist}
        handleselectionclose={handleSelectionClose}
        selectedFranchise={selectedFranchise}
        onContinue={handleContinueFromChild}
        handleBack={handleback}
        getsubjectlisting={getsubjectlisting}
        enData={enData}
      />
      <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', fontFamily: 'GT-Walsheim' }}>
        <StudentListModal
          isVisible={isModalVisible}
          onClose={() => setModalVisible(false)}
          students={studentlist}
          icons={icons}
          onSelectStudent={handleStudentSelect}
        />
      </View>
    </div>
  );
}